import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';

export default defineNuxtPlugin((nuxtApp) => {
    let isInitialized = false;

    const initAmplitude = () => {
        if (isInitialized || useRuntimeConfig().public.baseUrl.includes('localhost') || useRuntimeConfig().public.baseUrl.includes('dev')) {
            return;
        }

        const sessionReplayTracking = sessionReplayPlugin({
            sampleRate: 1
        });

        amplitude.add(sessionReplayTracking);
        amplitude.init(useRuntimeConfig().public.amplitudeID, {
            fetchRemoteConfig: true,
            autocapture: {
                "attribution":true,"fileDownloads":true,
                "formInteractions":true,
                "pageViews":true,
                "sessions":true,
                "elementInteractions":true,
                "networkTracking":true,
                "webVitals":true,
                "frustrationInteractions":{
                    "errorClicks":true,
                    "deadClicks":true,
                    "rageClicks":true
                }
            }
        });

        isInitialized = true;
    };

    const disableAmplitude = () => {
        if (isInitialized) {
            amplitude.reset();
            isInitialized = false;
        }
    };

    nuxtApp.hook('app:mounted', () => {
        const consentAnalytics = localStorage.getItem('silktideCookieChoice_performance') === 'true';

        if (consentAnalytics) {
            initAmplitude();
        }
    });

    window.addEventListener('consentPerformanceAccept', () => {
        initAmplitude();
    });

    window.addEventListener('consentPerformanceReject', () => {
        disableAmplitude();
    });
});

